import { createApi } from '@reduxjs/toolkit/query/react'
import getCustomFetchBase from '../custom-fetch-base'
import Strapi, { EndpointQueryParameters } from '../../types/strapi/strapi'
import getQuery from '../../helpers/api/get-query'
import Colorant from '../../types/api/colorant'

export const colorantsApi = createApi({
    reducerPath: 'colorantsApi',
    baseQuery: getCustomFetchBase({ baseUrl: import.meta.env.VITE_API_URL }),
    endpoints: builder => ({
        getColorants: builder.query<Strapi<Colorant>, EndpointQueryParameters | void>({
            query: getQuery('/colorants'),
        }),
    }),
})

export const { useGetColorantsQuery } = colorantsApi
